export const EVENT_START_TIME = new Date(Date.UTC(2025, 8, 21, 4, 0, 0)) // September is month 8 (0-indexed), 04:00 UTC is 1pm GMT+9
export const EVENT_NAME = "Abstract KBW"
export const EVENT_DESCRIPTION = "4 events. One epic week."
export const SOCIAL_TAP_POINT_REWARD = 1

export const ENABLE_SHOP = false

export const ENABLE_FRIEND_CONNECTIONS = false

export const COLLECT_WALLETS = true

export const CONNECTION_TERMS = {
    connection: "friend",
    pendingConnection: "friend request",
	connectAction: {
		currentTense: "share",
		pastTense: "shared details"
	},
	connectedAt: "You became friends"
}

export const POINTS_NAME: "tickets" | "points" = "tickets"

export const APP_BACKGROUND_IMAGE = "/images/abstract-kbw-bg.png"
export const APP_LOGO_IMAGE = "/images/logo.svg"

export const CHANNELS = [
	{ name: "twitter", label: "Twitter" },
	{ name: "telegram", label: "Telegram" },
	{ name: "instagram", label: "Instagram" },
] as const

export function getSocialChannelUrl(
	handle: string,
	channelName: string,
): string {
	switch (channelName) {
		case "twitter":
			return `https://twitter.com/${handle}`
		case "telegram":
			return `https://t.me/${handle}`
		case "instagram":
			return `https://instagram.com/${handle}`
		default:
			console.warn(`missing social channel url config for: ${channelName}`)
			return ""
	}
}
